// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.puzzleReviewContainer {
  position: relative;
  width: 208px;
  height: 208px;
  margin: 12px auto 0;
}
.puzzleReviewOverlayCanvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}
.puzzleReviewRowsContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.puzzleReviewBoardRow {
  display: flex;
  flex: 1;
  container-type: size;
  justify-content: center;
  align-items: center;
}
.puzzleReviewBoardSpaceContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/puzzleReviewBoard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,OAAO;EACP,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".puzzleReviewContainer {\n  position: relative;\n  width: 208px;\n  height: 208px;\n  margin: 12px auto 0;\n}\n.puzzleReviewOverlayCanvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n}\n.puzzleReviewRowsContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n.puzzleReviewBoardRow {\n  display: flex;\n  flex: 1;\n  container-type: size;\n  justify-content: center;\n  align-items: center;\n}\n.puzzleReviewBoardSpaceContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
